export default {
	jobApplications : [],
	talents : [],
	employees : [],
	employers : [],
	articles : [],
	specializations : [],
	positionLevels : [],
	industries : [],
	dressCodes : [],
	companySizes : [],
	jobTypes : [],
	spokenLanguages : [],
	qualifications : [],
	fetchCompanySizes : [],
	pushNotifications : [],
	creditPackageTransactions : [],
	candidateStaticContents : [],
	employerStaticContents : [],
	countries : [],
	states : [],
	dressCodesList : [],
	industriesList : [],
	companySizesList : [],
	spokenLanguagesList : [],
	appVersions : [],
	pendingEmployers : [],
	employerFaqs : [],
	candidateFaqs : [],
	companies : [],
	jobApplicationsByUserId : [],
	creditPackages : [],
	jobAdvertisements : [],
	jobAdvertisementsByCompanyId : [],
	specializationsList : [],
	activeCreditPackages : []
}